module.exports = __webpack_public_path__ + "static/konstantin-chaykin-c836b6a3a00058821c97195ab0bcbdef.png";